import router from '@/router'
import {
  apiSetlanguage,
  apiTo_logout,
  apiTo_login_by_token,
  apiTo_login_register,
  apiTo_login,
  apiTo_sms_code_login,
  apiValidateEnv,
} from '@/resource'
import store from '@/store'
import redirect from '@/util/redirect'
import { getRegulator } from '@/util/regulator'
import { MessageBox, Message } from 'element-ui'
import { setCookies } from '@/util/cookies'
import { insightechTrack } from '@/util/insightechTracking'
import { getAuditStatusByString } from '@/constants/auditStatus'
import registerStep, { getRegisterStep } from '@/constants/register/registerStep'
import { RegisterRoutePath } from '@/router/registerRoutes'
import poiStore from '@/store/register/poiVerification/poiStore'
import poaStore from '@/store/register/poaVerification/poaStore'
import ibtStore from '@/store/register/ibtVerification/ibtStore'
import { mapVerifiedAuth, getToPath } from '@/components/security/Security'
import { sensorsBindLogin, sensorsLogout, sensorsRegister } from './sensorsdata'
import i18n from '@/lang'

function setUserProfile(resp) {
  const userInfo = resp.data.data
  const poiAuditStatus = getAuditStatusByString(userInfo.identityProofStatus.poiAuditStatus)
  const poaAuditStatus = getAuditStatusByString(userInfo.identityProofStatus.poaAuditStatus)
  const ibtPoiAuditStatus = getAuditStatusByString(userInfo.identityProofStatus.ibtPoiAuditStatus)
  const ibtPoaAuditStatus = getAuditStatusByString(userInfo.identityProofStatus.ibtPoaAuditStatus)

  store.commit('common/setLoginStatus', true)
  store.commit('common/setFirstLoginToday', userInfo.firstLoginOfToday)
  store.commit('common/setUserName', userInfo.userName)
  store.commit('common/setUserId', userInfo.userId)
  store.commit('common/setEventEmailId', userInfo.eventEmailId)
  store.commit('common/setEventMobileId', userInfo.eventMobileId)
  store.commit('common/setIndividualName', userInfo.userName.split('&')[0].trim())
  store.commit('common/setUserType', userInfo.userType)
  store.commit('common/setUserTypeEnum', userInfo.userTypeEnum)
  store.commit('common/setOpenAccountAction', userInfo.openAccountActionEnabled)
  store.commit('common/setCountryCode', userInfo.countryCode)
  store.commit('common/setAccessToken', userInfo.accessToken)
  store.commit('common/setEmail', userInfo.email)
  setCookies('token', userInfo.accessToken, 30)
  store.commit('common/setAccountAuditStatus', getAuditStatusByString(userInfo.accountAuditStatus))
  store.commit('common/setPoiAuditStatus', poiAuditStatus)
  store.commit('common/setPoaAuditStatus', poaAuditStatus)
  store.commit('common/setIbtPoiAuditStatus', ibtPoiAuditStatus)
  store.commit('common/setIbtPoaAuditStatus', ibtPoaAuditStatus)
  store.commit('common/setId3Pass', userInfo.id3Pass ?? false)
  store.commit('common/setRegulator', getRegulator(userInfo.regulator))
  store.commit('common/setEmailMasked', userInfo.emailMasked)
  store.commit('common/setBeforeLoginCountry', resp.data.data.countryCode || '')

  sensorsRegister({
    is_login: true,
  })
  sensorsBindLogin(userInfo.userId, userInfo.eventEmailId, userInfo.eventMobileId)

  //pcs language
  store.dispatch('payment/actionSetPCSI18n')

  //if user didn't change language at login page, change the language by customer's preference
  if (!store.state.common.isChangedLangAtLandingPage) {
    store.commit('common/setLang', userInfo.language)
    //if changed, save the user's preference
  } else {
    apiSetlanguage({ language: store.state.common.lang })
  }
  store.commit('common/setIbUrl', userInfo.url)
  store.commit('common/setSalesCompany', userInfo.salesCompany)
  store.dispatch(
    'register/setStep',
    getRegisterStep(userInfo.registerStep, poaAuditStatus, store.getters['common/poaPass'])
  )
  if (userInfo.demo) store.commit('common/setDemo', true)
}

function relogin(resp) {
  MessageBox.confirm(resp.data.errmsg + ' Would you like to log out this account and then log in again?', 'Info', {
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
    type: 'info',
  }).then(() => {
    signOut(521)
  })
}

function signOut(method, reason) {
  console.log('signout')
  store.commit('common/setAuthHeaders', {
    etxId: '',
    eCode: '',
    ptxId: '',
    pCode: '',
    tCode: '',
  })

  const requestData = {
    reason: reason,
  }

  if (store.state.common.extras.logoutStacktrace) {
    requestData['stack'] = store.state.common.extras.logoutStacktrace
  }

  if (store.state.common.loginStatus || method === 521) {
    apiTo_logout(requestData).then(resp => {
      store.commit('common/setLoginStatus', '')
      store.commit('register/reset')
      store.commit('regulator/reset')
      store.commit('common/setSessionId', { sessionId: null, sessionInternalId: null })
      store.commit('payment/reset')
      store.commit('promotion/reset')
      poiStore.commit('reset')
      poaStore.commit('reset')
      ibtStore.commit('reset')
      store.commit('common/setAutoNotifyStatus')
      setCookies('token', '')
      sensorsRegister({
        is_login: false,
      })
      sensorsLogout()
      redirect.redirectToLogoutUrl()
    })
  } else {
    sensorsRegister({
      is_login: false,
    })
    sensorsLogout()
    redirect.redirectToLogoutUrl()
  }
}

// 避免注册成功后未退出连续注册新用户后仍使用前者的状态
function reRegisterReset() {
  store.commit('common/setLoginStatus', '')
  store.commit('register/reset')
  store.commit('regulator/reset')
  store.commit('common/setSessionId', { sessionId: null, sessionInternalId: null })
  store.commit('payment/reset')
  store.commit('promotion/reset')
  poiStore.commit('reset')
  poaStore.commit('reset')
  ibtStore.commit('reset')
  store.commit('common/setAutoNotifyStatus')
  setCookies('token', '')
}

// 提取code码为1201时的公共处理部分 邮箱登录、手机号登录、注册登录都需要该code码的处理
async function handleSecurityResp(resp, method, requestParams) {
  const respBody = resp.data.data
  store.commit('common/setBeforeLoginCountry', respBody.c || '')
  store.commit('common/setLoginCredentials', {
    method: method,
    request: requestParams,
  })
  store.commit('common/setEmailMasked', respBody.encodeEmail)
  store.commit('common/setRegulator', getRegulator(respBody.r))
  console.log('login-------', respBody)
  const isAuthStausTotpValidate = respBody.lackAuthMethods.includes('totp') && !respBody.authStatus.includes('totp')
  if (isAuthStausTotpValidate) {
    const resData = await apiValidateEnv()
    if (resData.data.data.allow == false) {
      MessageBox.alert(i18n.t('security.toolTipCustomer'), '', {
        dangerouslyUseHTMLString: true,
        customClass: 'my-custom-alert',
      })
      router.push('/login')
      return
    }
  }
  const lackAuthItems = respBody.lackAuthMethods?.map(item => {
    const showVerified = mapVerifiedAuth(item, respBody.authStatus)
    return {
      type: item,
      authenticated: false,
      verified: showVerified,
      path: getToPath(item, showVerified),
    }
  })
  let usedRequiredAuths = store.state.common.requiredAuths
  usedRequiredAuths['login'] = respBody.lackAuthMethods?.concat(respBody.effectiveAuthMethods)
  store.commit('common/setRequiredAuths', usedRequiredAuths)
  store.commit('common/setCheckedAuthStatus', lackAuthItems)
  const pushObject = lackAuthItems?.find(item => !item.authenticated)
  if (pushObject?.path != router.currentRoute.path) {
    router.push(pushObject?.path)
  }
}

export default {
  signIn(userName, password) {
    const requestParams = {
      userName_login: userName,
      password_login: password,
      utc: 39600000,
    }
    apiTo_login(requestParams)
      .then(resp => {
        if (resp.data.code === 427) {
          //Password reset every 90 days.
          const callbackData = resp.data.data
          router.push({
            name: 'forceChangePassword',
            params: {
              token: callbackData.token,
              maskedEmail: callbackData.email,
              callbackRegulator: callbackData.regulator,
            },
          })
        } else if (resp.data.code === 0) {
          store.commit('common/setAuthHeaders', {
            etxId: '',
            eCode: '',
            ptxId: '',
            pCode: '',
            tCode: '',
          })
          store.dispatch('regulator/actionGetInformation')
          setUserProfile(resp)

          if (resp.data.data.userTypeEnum == 'IB') redirect.redirectToIbPortal()
          else if (resp.data.data.demo) router.push('/homeDemo')
          else if (store.state.register.currStep < registerStep.idInformation)
            router.push(RegisterRoutePath.openAccount)
          else if (!store.getters['common/idPass']) router.push(RegisterRoutePath.register)
          // redirect promotion url
          else if (Object.values(router.currentRoute.query).length > 0)
            router.push(router.currentRoute.query?.['redirectUrl'])
          else router.push('/home')
        } else if (resp.data.code === 521) {
          //A user already logged in on this device
          relogin(resp)
        } else if (resp.data.code === 529) {
          //input wrong password more than 2 times and invoke slide verification
          store.commit('common/setFailedSecondTime', true)
        } else if (resp.data.code === 1201) {
          handleSecurityResp(resp, 'signIn', requestParams)
        } else if (resp.data.code === 1202) {
          store.commit('common/setAuthHeaders', {
            etxId: '',
            eCode: '',
            ptxId: '',
            pCode: '',
            tCode: '',
          })
          router.push('/login')
        }
      })
      .catch(error => {
        console.log('error', error)
      })
  },
  signInMobile(countryCode, phoneNumber, password) {
    const requestParams = {
      country_code: countryCode,
      mobile_login: phoneNumber,
      password_login: password,
      utc: 39600000,
    }
    apiTo_login(requestParams).then(resp => {
      if (resp.data.code === 427) {
        //Password reset every 90 days.
        const callbackData = resp.data.data
        router.push({
          name: 'forceChangePassword',
          params: {
            token: callbackData.token,
            maskedEmail: callbackData.email,
            callbackRegulator: callbackData.regulator,
          },
        })
      } else if (resp.data.code === 0) {
        store.dispatch('regulator/actionGetInformation')
        setUserProfile(resp)

        if (resp.data.data.userTypeEnum == 'IB') redirect.redirectToIbPortal()
        else if (resp.data.data.demo) router.push('/homeDemo')
        else if (store.state.register.currStep < registerStep.idInformation) router.push(RegisterRoutePath.openAccount)
        else if (!store.getters['common/idPass']) router.push(RegisterRoutePath.register)
        else if (Object.values(router.currentRoute.query).length > 0)
          router.push(router.currentRoute.query?.['redirectUrl'])
        else router.push('/home')
      } else if (resp.data.code === 521) {
        //A user already logged in on this device
        relogin(resp)
      } else if (resp.data.code === 529) {
        //input wrong password more than 2 times and invoke slide verification
        store.commit('common/setFailedSecondTime', true)
      } 
      else if (resp.data.code === 1201) {
        handleSecurityResp(resp, 'signInMobile', requestParams)
      } else if (resp.data.code === 1202) {
        store.commit('common/setAuthHeaders', {
          etxId: '',
          eCode: '',
          ptxId: '',
          pCode: '',
          tCode: '',
        })
        router.push('/login')
      }
    })
  },
  signOut(method, reason) {
    signOut(method, reason)
  },
  refreshToken(accessToken, pk, path) {
    apiTo_login_by_token({
      headers: {
        accessToken: accessToken,
        pk: pk,
      },
    }).then(resp => {
      if (resp.data.code === 0) {
        store.dispatch('regulator/actionGetInformation')
        store.commit('common/setAutoNotifyStatus', false)
        setUserProfile(resp)
        if (path) router.push(path)
        else router.push('/home')
      } else if (resp.data.code === 1500) {
        router.push('/home')
      }
    })
  },
  async register(registerToken) {
    reRegisterReset()
    apiTo_login_register({
      a: registerToken,
    }).then(resp => {
      if (resp.data.code === 0) {
        store.commit('common/setLoginCredentials', { method: 'register', request: null })
        store.dispatch('regulator/actionGetInformation')
        setUserProfile(resp)

        // 避免注册成功后未退出连续注册新用户后仍使用前者的状态
        store.commit('common/setAuthHeaders', {
          etxId: '',
          eCode: '',
          ptxId: '',
          pCode: '',
          tCode: '',
        })

        if (resp.data.data.userTypeEnum == 'IB') redirect.redirectToIbPortal()
        else if (resp.data.data.propTrading) {
          // Tracking code
          insightechTrack('ptclient', 'newpt')
          // 2024年11月21日补齐 官网跳转cp逻辑
          router.push({ name: 'propTradingCreateAccount' })
        } else if (resp.data.data.demo) router.push('/demo')
        else if (store.state.register.currStep < registerStep.idInformation) {
          // Redirect to '/register' for register redirection
          store.dispatch('register/setIsRegisterPath', true)
          router.push(RegisterRoutePath.registerWelcome)
        } else if (!store.getters['common/idPass']) router.push(RegisterRoutePath.register)
        else router.push('/home')
      } else if (resp.data.code === 1201) {
        handleSecurityResp(resp, 'register', { a: registerToken })
      } else if (resp.data.code === 1202) {
        store.commit('common/setAuthHeaders', {
          etxId: '',
          eCode: '',
          ptxId: '',
          pCode: '',
          tCode: '',
        })
        router.push('/login')
      } else {
        router.push('/login')
      }
    })
  },
  smsCodeLogin(token) {
    apiTo_sms_code_login({
      b: token,
    }).then(resp => {
      console.log(resp)
      if (resp.data.code === 0) {
        store.dispatch('regulator/actionGetInformation')
        setUserProfile(resp)
        if (resp.data.data.resetMobilePassword) {
          router.push({
            path: 'resetPasswordMobile',
            query: { resetToken: resp.data.data.accessToken },
          })
        }
      } else {
        router.push('/login')
      }
    })
  },
}
